<template>
  <GlobalWindow
    :title="`配置${moduleData.name}数据`"
    width="1000px"
    :visible.sync="visible"
    :with-footer="false"
  >
    <TableLayout class="module-data-table-layout" :permissions="['module:datarow:query']" :with-breadcrumb="false">
      <template v-slot:table-wrap>
        <ul class="toolbar">
          <li><el-button type="primary" @click="create" icon="el-icon-plus" v-permissions="['module:datarow:create']">新建</el-button></li>
          <li><el-button type="primary" @click="random" icon="el-icon-plus" v-permissions="['module:datarow:create']">自动创建数据</el-button></li>
          <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['template:delete']">删除</el-button></li>
        </ul>
        <!-- 参数列表 -->
        <el-table
          :data="tableData.list"
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            v-for="column in columns"
            :key="column.variable"
            :prop="column.variable"
            :label="column.label"
            min-width="100px"
          >
            <template slot-scope="{ row }">
              <template v-if="column.dataType === 'TEXT'">{{row[column.variable]}}</template>
              <template v-else-if="column.dataType === 'NUMBER'">{{row[column.variable]}}</template>
              <img v-else-if="column.dataType === 'IMAGE'" :src="row[column.variable]"/>
            </template>
          </el-table-column>
          <el-table-column
            v-if="containPermissions(['module:datarow:update', 'module:datarow:create', 'module:datarow:delete'])"
            label="操作"
            min-width="120"
            fixed="right"
          >
            <template slot-scope="{row}">
              <el-button type="text" icon="el-icon-edit" @click="$refs.operaModuleDataWindow.open('编辑', row, moduleData)" v-permissions="['module:datarow:update']">编辑</el-button>
              <el-button v-if="!row.fixed" type="text" icon="el-icon-delete" @click="deleteById(row)" v-permissions="['module:datarow:delete']">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :pagination="tableData.pagination"
        >
        </pagination>
      </template>
    </TableLayout>
    <OperaModuleDataWindow ref="operaModuleDataWindow" @success="search"/>
  </GlobalWindow>
</template>

<script>
import TableLayout from '@/layouts/TableLayout'
import BaseTable from '@/components/base/BaseTable'
import Pagination from '@/components/common/Pagination'
import GlobalWindow from '../common/GlobalWindow'
import OperaModuleDataWindow from './OperaModuleDataWindow'

export default {
  name: 'ModuleDataTableWindow',
  extends: BaseTable,
  components: {
    OperaModuleDataWindow,
    GlobalWindow,
    Pagination,
    TableLayout
  },
  data () {
    return {
      visible: false,
      searchForm: {
        moduleId: null
      },
      moduleData: {}
    }
  },
  computed: {
    columns () {
      if (this.moduleData.fieldConfig == null) {
        return []
      }
      return JSON.parse(this.moduleData.fieldConfig)
    }
  },
  methods: {
    /**
     * 打开窗口
     */
    open (moduleData) {
      this.moduleData = moduleData
      this.searchForm.moduleId = moduleData.id
      this.visible = true
      this.search()
    },
    // 新建
    create () {
      if (this.columns.length === 0) {
        this.$tip.warning('请配置模块字段后再新建数据')
        return
      }
      this.$refs.operaModuleDataWindow.open('新建', null, this.moduleData)
    },
    // 随机生成数据
    random () {
      if (this.columns.length === 0) {
        this.$tip.warning('请配置模块字段后再生成数据')
        return
      }
      this.api.random(this.moduleData.id)
        .then(() => {
          this.search()
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    /**
     * 页码变更处理（分页时触发）
     *
     * @param pageIndex 新页码
     */
    handlePageChange (pageIndex) {
      this.tableData.pagination.pageIndex = pageIndex || this.tableData.pagination.pageIndex
      this.isWorking.search = true
      this.api.fetchList({
        page: this.tableData.pagination.pageIndex,
        capacity: this.tableData.pagination.pageSize,
        model: this.searchForm,
        sorts: this.tableData.sorts
      })
        .then(data => {
          this.tableData.list = data.records.map(row => {
            const dynamicFieldConfig = JSON.parse(row.value)
            const dynamicFields = {}
            for (const key in dynamicFieldConfig) {
              dynamicFields[key] = dynamicFieldConfig[key]
            }
            return {
              ...row,
              ...dynamicFields
            }
          })
          this.tableData.pagination.total = data.total
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking.search = false
        })
    }
  },
  created () {
    this.config({
      module: '数据',
      api: '/module/data.js',
      'field.id': 'id',
      'field.main': null,
      sorts: [
        { direction: 'DESC', property: 'CREATE_TIME' }
      ]
    })
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/variables";
.module-data-table-layout {
  /deep/ .table-content {
    padding: 0;
    .table-wrap {
      padding: 0;
    }
  }
  /deep/ .el-table__row {
    img {
      width: 80px;
    }
  }
}
</style>
